// extracted by mini-css-extract-plugin
export var cartIcon = "_oa-0";
export var cartIconContainer = "_oa-1";